import { render, staticRenderFns } from "./Energy.vue?vue&type=template&id=68c4d681&scoped=true&"
import script from "./Energy.vue?vue&type=script&lang=js&"
export * from "./Energy.vue?vue&type=script&lang=js&"
import style0 from "./Energy.vue?vue&type=style&index=0&id=68c4d681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4d681",
  null
  
)

export default component.exports